<template>

  <PrevisionaleUscite />
 
</template>

<script>
import PrevisionaleUscite from '../components/pratiche/PrevisionaleUscite.vue'

export default {
  components: {
    PrevisionaleUscite

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>

